module.exports = __webpack_public_path__ + "static/assets/482dc5011057fe26e9542e9476601bf2.png";